import { defineStore } from 'pinia'
import { computed, ref } from 'vue'

export const usePageConfigurationStore = defineStore(
  'ssr_page_configuration',
  () => {
    const disableBranding = ref<boolean>(false)

    const hasBranding = computed<boolean>(() => !disableBranding.value)

    const showLogo = computed<boolean>(() => {
      if (__CAPACITOR__) {
        return true
      }

      return hasBranding.value !== false
    })

    return {
      disableBranding,
      hasBranding,
      showLogo,
    }
  },
  {
    persist:
      import.meta.env.SSR || __CAPACITOR__
        ? false
        : {
          storage: window.sessionStorage,
          pick: ['disableBranding'],
        },
  },
)
